import React, { useState } from 'react';
import SEO from '../components/SEO';
import { WEB3FORMS_ACCESS_KEY } from '../utils/web3forms';

const Contact = () => {
  const [status, setStatus] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setSubmitting(true);
    setStatus(null);
    const form = event.currentTarget;
    const data = new FormData(form);

    try {
      const res = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        body: data,
      });
      if (res.ok) {
        setStatus({ type: 'ok', message: "Thanks — we'll be in touch within one business day." });
        form.reset();
      } else {
        throw new Error('Submission failed');
      }
    } catch {
      setStatus({ type: 'err', message: 'Something went wrong. Try emailing jjohnson@aurablox.com directly.' });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="page contact-page">
      <SEO
        title="Contact AURABLOX"
        description="Discuss a 90-day commercial data foundation engagement. Tell us about your Databricks environment, reporting deadline, and technical sponsor."
        path="/contact"
      />

      <header className="page-head" id="top">
        <div className="page-head__text">
          <h1 className="kinetic-title">Let’s fix the data foundation.</h1>
          <p className="page-head__lede">
            Tell us which reporting or AI deadline is at risk, where your data lives, and who can help move the work forward.
          </p>
        </div>
      </header>

      <main>
        <section className="section" aria-labelledby="reach">
          <div className="contact-portal">
            <div className="contact-portal__intro">

              <h2 id="reach">Talk directly with the team</h2>
              <p className="contact-portal__lede">
                We’ll review the commercial data problem, platform readiness, and sponsor availability before arranging a scoping conversation.
              </p>

              <div className="contact-commitments">
                <div className="contact-commitment">
                  <span className="contact-commitment__num">01</span>
                  <div className="contact-commitment__text">
                    <strong>A focused data conversation</strong>
                    <p>Your note goes to the team responsible for architecture and delivery.</p>
                  </div>
                </div>
                <div className="contact-commitment">
                  <span className="contact-commitment__num">02</span>
                  <div className="contact-commitment__text">
                    <strong>Confirm readiness</strong>
                    <p>We check the deadline, access path, cloud budget, and decision owner.</p>
                  </div>
                </div>
                <div className="contact-commitment">
                  <span className="contact-commitment__num">03</span>
                  <div className="contact-commitment__text">
                    <strong>Agree measurable acceptance</strong>
                    <p>Scope, delivery gates, and verification are defined before the build.</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="contact-portal__form-wrap" id="inquiry" tabIndex={-1} role="region" aria-label="Project inquiry">
              <form onSubmit={handleSubmit} className="contact-portal__form">
                <input type="hidden" name="access_key" value={WEB3FORMS_ACCESS_KEY} />
                <input type="hidden" name="subject" value="Commercial Data Foundation Inquiry" />
                <input type="checkbox" name="botcheck" style={{ display: 'none' }} readOnly />

                <div className="contact-portal__grid">
                  <div className="contact-field">
                    <label htmlFor="contact-name" className="contact-label">Your name *</label>
                    <input
                      id="contact-name"
                      type="text"
                      name="name"
                      placeholder="e.g. Alex Mercer"
                      required
                      className="contact-input"
                    />
                  </div>

                  <div className="contact-field">
                    <label htmlFor="contact-email" className="contact-label">Work email *</label>
                    <input
                      id="contact-email"
                      type="email"
                      name="email"
                      placeholder="alex@company.com"
                      required
                      className="contact-input"
                    />
                  </div>

                  <div className="contact-field">
                    <label htmlFor="contact-company" className="contact-label">Company / organization</label>
                    <input
                      id="contact-company"
                      type="text"
                      name="company"
                      placeholder="Acme Corp"
                      className="contact-input"
                    />
                  </div>

                  <div className="contact-field">
                    <label htmlFor="contact-timeline" className="contact-label">Target timeline</label>
                    <input
                      id="contact-timeline"
                      type="text"
                      name="timeline"
                      placeholder="e.g. This quarter / Immediate"
                      className="contact-input"
                    />
                  </div>

                  <div className="contact-field contact-field--full"><label htmlFor="reporting-risk" className="contact-label">Is a reporting or AI deadline at risk? *</label><select id="reporting-risk" name="reporting_deadline_at_risk" className="contact-input" required defaultValue=""><option value="" disabled>Select an answer</option><option>Yes — a defined deadline is at risk</option><option>We are assessing the impact</option><option>No immediate deadline</option></select></div>
                  <div className="contact-field"><label htmlFor="platform-ready" className="contact-label">Cloud / Databricks budget *</label><select id="platform-ready" name="platform_budget" className="contact-input" required defaultValue=""><option value="" disabled>Select an answer</option><option>Established environment and budget</option><option>Provisioning approved</option><option>Not yet approved</option></select></div>
                  <div className="contact-field"><label htmlFor="technical-sponsor" className="contact-label">Sponsor can approve within five business days? *</label><select id="technical-sponsor" name="technical_sponsor_readiness" className="contact-input" required defaultValue=""><option value="" disabled>Select an answer</option><option>Yes — an authorized sponsor is available</option><option>We need to confirm the sponsor</option><option>Not currently</option></select></div>
                  <div className="contact-field contact-field--full">
                    <label htmlFor="contact-message" className="contact-label">Your commercial data problem *</label>
                    <textarea
                      id="contact-message"
                      name="message"
                      required
                      rows={5}
                      className="contact-textarea"
                      placeholder="Which feeds or entities need reconciliation? What reporting or AI deadline is at risk? Describe the platform and desired outcome without including confidential records."
                    />
                  </div>
                </div>

                <div className="contact-portal__footer">
                  <button type="submit" disabled={submitting} className="btn btn--primary contact-portal__submit">
                    {submitting ? 'Sending Request…' : 'Discuss the engagement ↗'}
                  </button>

                  {status && (
                    <p className={`contact-status contact-status--${status.type}`}>
                      {status.message}
                    </p>
                  )}

                  <p className="contact-portal__fallback">
                    Prefer direct email? <a href="mailto:jjohnson@aurablox.com">Write to Josh directly at jjohnson@aurablox.com</a>
                  </p>
                </div>
              </form>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default Contact;
